var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket-state",class:{'ticket-state_blink': _vm.hasBlink}},[_c('div',{staticClass:"ticket-state__text"},[_vm._v(" "+_vm._s(_vm.item.ticketNumber)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }